import { RecipientBiometryMetaDTO } from '../../../services/standalone-charges';

export const MAX_RECIPIENT_ATTEMPTS = 3;

export const biometryRejectedCopy = {
  title: 'Biometria recusada',
  description:
    'Não foi possível validar a identidade na Pagar.me. Para tentar novamente, vamos criar um novo cadastro de recebedor.',
  limitReached:
    'Limite de tentativas atingido. Entre em contato com o suporte para continuar.',
  supportRequired:
    'Seu cadastro precisa de análise manual. Entre em contato com o suporte para obter ajuda.'
};

export const biometryPendingCopy = {
  title: 'Aguardando biometria',
  description:
    'Conclua a prova de vida na Pagar.me para liberar a emissão de cobranças.'
};

export const formatAttemptCounter = (
  attemptCount = 0,
  maxAttempts = MAX_RECIPIENT_ATTEMPTS
): string => `${attemptCount} de ${maxAttempts} tentativas utilizadas`;

export const getRemainingAttempts = (
  attemptCount = 0,
  maxAttempts = MAX_RECIPIENT_ATTEMPTS
): number => Math.max(0, maxAttempts - attemptCount);

export const isBiometryRejectedMeta = (meta?: RecipientBiometryMetaDTO | null): boolean =>
  Boolean(meta?.biometryRejected);

export const isSupportRequiredMeta = (meta?: RecipientBiometryMetaDTO | null): boolean =>
  Boolean(meta?.supportRequired);

export const canRetryBiometryMeta = (meta?: RecipientBiometryMetaDTO | null): boolean =>
  Boolean(meta?.canRetryBiometry);
